module.exports = __webpack_public_path__ + "img/icon_fp_kakao.22865f35.svg";